import { render } from "./SyncShopProduct.vue?vue&type=template&id=10e4bbc2&scoped=true&ts=true"
import script from "./SyncShopProduct.vue?vue&type=script&lang=ts"
export * from "./SyncShopProduct.vue?vue&type=script&lang=ts"

import "./SyncShopProduct.vue?vue&type=style&index=0&id=10e4bbc2&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e4bbc2"]])

export default __exports__